// removed by extract-text-webpack-plugin
module.exports = {"container":"_1f-q2dBg9fmfqe_GMIzfKu","title":"_3yvIHieUI-4e5nakC41rI0","name":"_3O9e9jWtb1qGN4nEXHHFu6","state":"_8T86tFhAXC_aSsHXh_V20"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Document/styles.css
// module id = 2828
// module chunks = 0